// extracted by mini-css-extract-plugin
export default {"MenuCont":"Menu_MenuCont__n878Z","menuOptionShell":"Menu_menuOptionShell__Hs7AH","menuOption":"Menu_menuOption__hUrK8","menuImg":"Menu_menuImg__6M1sn"};